
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Industries() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  const industries = [
    {
      title: 'Home Services',
      description: 'Transform inbound demand into structured revenue pipelines. AI-driven call handling, scheduling intelligence, and operational control.',
      icon: 'ri-home-gear-line',
      image: 'https://public.readdy.ai/ai/img_res/4218f67378bba04815aa9bb4e609918d.jpg'
    },
    {
      title: 'Professional Services',
      description: 'Precision intake. Intelligent routing. Automated qualification systems that increase efficiency and client acquisition velocity.',
      icon: 'ri-briefcase-line',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20representation%20of%20professional%20business%20intelligence%20with%20golden%20data%20flow%20lines%20on%20dark%20navy%20background%20clean%20geometric%20network%20nodes%20representing%20client%20routing%20and%20qualification%20premium%20corporate%20illustration%20style%20no%20text&width=600&height=400&seq=indapple02&orientation=landscape'
    },
    {
      title: 'Healthcare & Medical',
      description: 'Operational intelligence without compromising patient trust. Secure automation for scheduling, follow-ups, and patient communication.',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20representation%20of%20healthcare%20technology%20with%20golden%20pulse%20lines%20and%20secure%20data%20nodes%20on%20dark%20navy%20background%20clean%20geometric%20shapes%20representing%20patient%20communication%20systems%20premium%20corporate%20illustration%20style%20no%20text&width=600&height=400&seq=indapple03&orientation=landscape'
    }
  ];

  return (
    <section id="industries" className="py-28 md:py-40 bg-white">
      <div ref={ref} className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className={`text-center mb-20 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-6">
            Who We Serve
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-[#1d1d1f] leading-[1.1]">
            Industries We Serve
          </h2>
          <p className="text-base font-light text-[#86868b] mt-5 max-w-xl mx-auto">
            Tailored AI infrastructure for organizations that demand precision, scalability, and measurable results.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className={`group rounded-2xl overflow-hidden bg-[#fafafa] border border-[#e8e8e8] hover:border-[#D4AF37]/30 transition-all duration-500 cursor-default ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${200 + index * 100}ms` : '0ms' }}
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  title={`${industry.title} AI automation solutions`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#D4AF37]/10 rounded-lg">
                    <i className={`${industry.icon} text-[#D4AF37] text-sm`}></i>
                  </div>
                  <h3 className="text-lg font-serif text-[#1d1d1f]">
                    {industry.title}
                  </h3>
                </div>
                <p className="text-sm font-light text-[#86868b] leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center mt-14 transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <a
            href="#consultation"
            className="inline-block text-sm font-medium text-[#D4AF37] hover:text-[#C19B2E] transition-colors cursor-pointer whitespace-nowrap group"
          >
            View Industry Solutions
            <span className="inline-block ml-1.5 group-hover:translate-x-1 transition-transform duration-300">&rarr;</span>
          </a>
        </div>
      </div>
    </section>
  );
}
